import { Tooltip } from "antd";
import React from "react";

import "./ACColumnTitleWithHelpText.less";

type ACColumnTitleWithHelpTextProps = {
  title: React.ReactNode;
  tooltipContent: React.ReactNode;
};

const ACColumnTitleWithHelpText: React.FC<ACColumnTitleWithHelpTextProps> = ({
  title,
  tooltipContent,
}) => {
  return (
    <div className="ac-column-title-with-help-text">
      <Tooltip title={tooltipContent}>
        <div
          className="column-title"
          title={typeof title === "string" ? title : undefined}
        >
          {title}
        </div>
      </Tooltip>
    </div>
  );
};

export default ACColumnTitleWithHelpText;
